// Alpaka-Sprint Easteregg: die Engine wird erst beim Klick auf "Spiel starten" nachgeladen
document.addEventListener('DOMContentLoaded', () => {
	const section = document.querySelector('[data-alpaka-game]');
	if (!section) return;

	const startButton = section.querySelector('[data-game-start]');
	const intro = section.querySelector('[data-game-intro]');
	const stage = section.querySelector('[data-game-stage]');

	let engine = null;

	startButton?.addEventListener('click', async () => {
		if (engine) return;

		const { createAlpakaGame } = await import('./alpakaGameEngine.js');

		intro?.classList.add('hidden');
		stage?.classList.remove('hidden');
		stage?.classList.add('flex');

		// sonst bleibt der Start-Button fokussiert und schluckt die Leertaste
		document.activeElement?.blur();

		engine = createAlpakaGame(section);
		engine.start();
	});
});
